"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductPreviewContainer = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const common_components_1 = require("@as-react/common-components");
const react_redux_1 = require("react-redux");
const ProductPreview_1 = tslib_1.__importDefault(require("../../components/product-detail/product-preview/ProductPreview"));
const ProductSelector_1 = require("../../redux/product/selectors/ProductSelector");
const ProductPreviewSelectors_1 = require("../../redux/productPreview/selectors/ProductPreviewSelectors");
const ProductPreviewActions_creators_1 = require("../../redux/productPreview/actions/ProductPreviewActions.creators");
const AddToWishlistButton_1 = tslib_1.__importDefault(require("../../components/product-detail/add-to-wishlist-button/AddToWishlistButton"));
const cotopaxi_1 = require("@as/cotopaxi");
const WishListActions_creators_1 = require("../../redux/wishList/actions/WishListActions.creators");
const WishListSelectors_1 = require("../../redux/wishList/selectors/WishListSelectors");
const ProductPreviewContainer = () => {
    const { isShopLanding } = (0, common_components_1.useAemConfig)();
    const selectedColorId = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetSelectedColorId)());
    const showImageTouchZoomHint = (0, react_redux_1.useSelector)((0, ProductPreviewSelectors_1.makeGetShowImageTouchZoomHint)());
    const dispatch = (0, react_redux_1.useDispatch)();
    const selectedSku = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetSelectedSku)());
    const { productCode, productId } = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetProductDefaults)());
    const productColorIsInWishList = (0, react_redux_1.useSelector)((0, WishListSelectors_1.makeGetProductColorIsInWishList)());
    const wishListProduct = {
        colorId: selectedColorId,
        productCode: productCode,
        productId: parseInt(productId, 10),
        sku: selectedSku,
    };
    const handleToggleWishlist = () => {
        dispatch(WishListActions_creators_1.wishListActions.toggleProduct(wishListProduct));
    };
    const handleImageTouchZoom = () => {
        dispatch(ProductPreviewActions_creators_1.productPreviewActions.disableImageTouchZoomHint());
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ProductPreview_1.default, { productId: productId, selectedColorId: selectedColorId, showImageTouchZoomHint: showImageTouchZoomHint, onImageTouchZoom: handleImageTouchZoom }), !isShopLanding && ((0, jsx_runtime_1.jsx)(AddToWishlistButton_1.default, { isProductInWishList: productColorIsInWishList, onToggle: handleToggleWishlist, wishListProduct: wishListProduct, buttonProps: {
                    shape: cotopaxi_1.ButtonShape.PILL,
                    variant: cotopaxi_1.ButtonVariant.INVERSE_ALT,
                    size: cotopaxi_1.ButtonSize.NORMAL,
                } }))] }));
};
exports.ProductPreviewContainer = ProductPreviewContainer;
